@for (breadcrumb of breadcrumbs; track breadcrumb.name; let i = $index) {
  <span>
    @if (i < breadcrumbs.length - 1) {
      <a class="breadcrumb-style" [routerLink]="breadcrumb.url">{{ breadcrumb.name }}</a>
    }
    @if (i === breadcrumbs.length - 1) {
      <span class="last-breadcrumb">{{ breadcrumb.name }}</span>
    }
    @if (i < breadcrumbs.length - 1) {
      <span>&nbsp;/&nbsp;</span>
    }
  </span>
}
